import { parseCookies } from "nookies";
import type { CookieKeyType } from "~/const/cookie";
import { uriConverter } from "~/util/uri-converter";

/**
 * - 指定された name を持つ Cookie の値を返す
 * - 指定したcookieが未定義の場合undefinedを返す
 */
export const getCookie = (name: CookieKeyType) => {
  const cookies = parseCookies();

  return cookies[name] ? uriConverter.decode(cookies[name]) : undefined;
};
